import { Fragment, ReactElement } from 'react';

import { MarriageDetailAnscNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/ansc-notifications.crumbs';
import PersonMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-marriage-non-resident/edit-person';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonMarriageNonResidentNotificationsCivilStatusShared
        scope={IdAmbito.Iscrizioni}
        items={MarriageDetailAnscNotificationsNonResidentSubscriptionCrumbs()}
      />
    </Fragment>
  );
};

PersonMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default PersonMarriageNonResidentNotificationsCivilStatusPage;
